import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalService {

  key = "123";

  public saveData(key: string, value: string) {
    localStorage.setItem(key+'_'+environment.environment, this.encrypt(value));
  }

  public saveObjData(key: string, value: object) {
    localStorage.setItem(key+'_'+environment.environment, this.encrypt(JSON.stringify(value)));
  }

  public savePlainObjData(key: string, value: object) {
    localStorage.setItem(key+'_'+environment.environment, JSON.stringify(value));
  }

  public setItem(key: string, value: string) {
    localStorage.setItem(key+'_'+environment.environment, value);
  }

  public getItem(key: string) {
    return localStorage.getItem(key+'_'+environment.environment);
  }
  public clear() {
    localStorage.clear();
  }
  public clearAll() {
    localStorage.clear();
    sessionStorage.clear();
  }



  public getData(key: string) {
    const data = localStorage.getItem(key+'_'+environment.environment) || "";
    return this.decrypt(data);
  }

  public getObjData(key: string) {
    const data = localStorage.getItem(key+'_'+environment.environment) || null;
    return data ? JSON.parse(this.decrypt(data)) : null;
  }

  public getPlainObjData(key: string) {
    const data = localStorage.getItem(key+'_'+environment.environment) || null;
    return data ? JSON.parse(data) : null;
  }

  public removeData(key: string) {
    localStorage.removeItem(key+'_'+environment.environment);
  }

  public clearData() {
    localStorage.clear();
  }

  private encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, this.key).toString();
  }

  private decrypt(txtToDecrypt: string) {
    return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8);
  }
}
